import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluidz" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexPagenation',
  setup(__props) {

const SimplePagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/SimplePagination.vue"))
const DisabledPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/DisabledPagination.vue"))
const IconsPagenation = defineAsyncComponent(() => import("@/components/theme/advance/pagination/IconsPagenation.vue"))
const RoundedPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/RoundedPagination.vue"))
const AlignmentsPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/AlignmentsPagination.vue"))
const SizingPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/SizingPagination.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(SimplePagination)),
      _createVNode(_unref(DisabledPagination)),
      _createVNode(_unref(IconsPagenation)),
      _createVNode(_unref(RoundedPagination)),
      _createVNode(_unref(AlignmentsPagination)),
      _createVNode(_unref(SizingPagination))
    ])
  ]))
}
}

})